import React from "react";
import PropTypes from "prop-types";

export default function RestlessDisplayLarge({ label, content, ...rest }) {
  return (
    <div {...rest}>
      <h4 className="mb-4">{label}</h4>
      <p>{content}</p>
    </div>
  );
}

RestlessDisplayLarge.propTypes = {
  label: PropTypes.string,
  content: PropTypes.string.isRequired,
};
